import React from 'react';
import { useParams } from 'react-router-dom';
import withRouter from '../../../../helpers/withRouter';
import { makeStyles } from "@mui/styles";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Box
} from "@mui/material";
import {Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent} from "@mui/lab";
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import {cfg} from "../../../../config";
import { getBase64 } from '../../../../helpers';

import GetAppIcon from '@mui/icons-material/GetApp';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PublishIcon from '@mui/icons-material/Publish';
//import { ThemeProvider, createTheme } from "@mui/material/styles";
import { DropzoneArea } from '../../../common/DropzoneArea';
import { toast } from 'react-toastify';

// const useStyles = makeStyles({
//   timeline_item: {
//     '&:before': {
//       flex: 0,
//       padding: 0,
//     }
//   },
//   content1: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     margin: '20px 0'
//   },
//   dropzoneContainer: {
//     border: 'dashed 1px lightgray',
//     borderRadius: '5px',
//     width: '100%',
//     marginTop: 20
//   },
//   dropzoneInnerContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     padding: 20,
//     position: 'relative'
//   },
//   dropzone: {
//     position:"absolute",
//     outline:"none !important",
//     width:"100%",
//     height:"100%",
//     cursor:"pointer",
//     opacity:"0",
//     marginTop: -20
//   },
//   dropzonearea: {
//     minHeight: '0px', // reduce component height
//     '& div': {
//       '& p': {
//         fontSize: "16px",
//       }
//     }
//   },
//   dragging: {
//     border: 'solid 1px red'
//   }
// })

const ImportData = props => {
  const params = useParams();

  const {missionMix, aircraft} = props;
  const [open, setOpen] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState(null);
  const [uploadFilename, setUploadFilename] = React.useState("");
  const [isUploading, setIsUploading] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleClose = () => {
    console.log("handleClose")
    setUploadFile(null);
    setOpen(false);
  }

  //const classes = useStyles();

  // const theme = createTheme({
  //   overrides: {
  //     MuiDropzoneArea: {
  //       root: {
  //         minHeight: '', // reduce component height
  //       },
  //       text: {
  //         fontSize: '16px',
  //       },
  //     }
  //   }
  // });

  const download = async () => {
    await props.saveDraft();

    // console.log('... sleeping for 1 second')
    // await sleep(1000); // temporary workaround for eventual consistent read issue in analyze-post (latest data not always fetched)

    fetchAuthSession()
      .then(session => {
        setIsDownloading(true);
        axios.post(`${cfg.apiUrl}/app/aspec/template`, {
          "id": params.id,
          "projectId": params.projectId
        }, {
          headers: {
            "Authorization": session.tokens?.idToken,
            "Content-Type": "application/json"
          }
        })
          .then(resp => {
            if(resp.status === 200) {
              let url = resp.data.url.split('?')[0]
              console.log(resp.data.url)
              console.log(url)
              window.open(resp.data.url, '_blank')
              props.updateData(url, 'args.template')
            }
          })
          .catch(e => console.log(e))
          .finally(e => setIsDownloading(false))
      })
  }

  const submit = async () => {
    fetchAuthSession()
      .then(async session => {
        setIsUploading(true);

        await props.saveDraft(); // Force save (analysis.args and analysis.data do not exist until the analysis is saved)

        console.log("... sleeping for 1 second");
        await sleep(1000); // temporary workaround for eventual consistent read issue in analyze-post (latest data not always fetched)

        axios.patch(`${cfg.apiUrl}/app/aspec/template`, {
          "id": params.id,
          "projectId": params.projectId,
          "file": removeBase64Header(uploadFile)
        }, {
          headers: {
            "Authorization": session.tokens?.idToken,
            "Content-Type": "application/json"
          }
        })
          .then(async resp => {
            if (resp.status === 200) {
              // Close form
              toast.success(`Data imported succesfully`, 'SUCCESS', 10000);
              setOpen(false);
              await props.refresh();
            } else {
              toast.warning(
                'Something went wrong, please check console for response.',
                'WARNING'
              );
            }
          })
          .catch((err) => {
            console.log(err)
            if (err.response) {
              if (err.response.status === 400) {
                toast.error(`The import failed: ${err.response.data.error.message}`, 'Error', 10000);
                return
              }
            }
            toast.error('An error has occurred, please try again.', 'Error');
          })
          .finally(e => setIsUploading(false))
      })
  }

  const shortHandFile = () => {
    let ac = aircraft.replace(/ /g,"_");
    return(`${ac}`)
  }

  const handleFileChange = async (files) => {
    // Reset inputFile if the input file is removed from the UI
    if (files.length === 0) {
      setUploadFile(null); // reset inputFile
      return;
    }

    // Get the input file as base64 and update the state with the callback
    setUploadFilename(files[0].name);
    getBase64(files[0], setUploadFile); // prints the base64 string
  };

  const removeBase64Header = file => {
    return file.split('base64,')[1]
  };

  // function DropzoneArea(props) {
  //   const {acceptedFiles, getRootProps, getInputProps} = useDropzone(
  //     {
  //       accept: {
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  //       }
  //     }
  //   );

  //   const files = acceptedFiles.map(file => (
  //     <li key={file.path}>
  //       {file.path} - {file.size} bytes
  //     </li>
  //   ));

  //   return (
  //     <section className="container">
  //       <div {...getRootProps({className: 'dropzone'})}>
  //         <input {...getInputProps()} />
  //         <p>Drag 'n' drop some files here, or click to select files</p>
  //         <em>(Only *.xlsx files will be accepted)</em>
  //       </div>
  //       <aside>
  //         <h4>Files</h4>
  //         <ul>{files}</ul>
  //       </aside>
  //     </section>
  //   );
  // }

  return(
    <>
      <Button
        disabled={props.status || props.isRunning || props.isSaving}
        onClick={() => setOpen(i => !i)}
        style={{marginRight: 20}}
        variant={'outlined'}
        size={'small'}>
          Import data (.xslx)
        </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="import-analysis-dialog">Import Analysis Data</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please follow the steps below and upload the .xlsx file filled with data in order to import analysis data
          </DialogContentText>
          <Timeline align={'left'}>
            <TimelineItem sx={{
                  "&": {
                    '&:before': {
                      flex: 0,
                      padding: 0,
                    }
                  }
                }}>
              <TimelineSeparator>
                <TimelineDot>
                  <GetAppIcon />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography>Download .xlsx template if needed</Typography>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  margin: '20px 0'
                }}>
                  <div>
                    <Typography variant={'caption'}>Mission Mix:</Typography>
                    <Typography>{missionMix}</Typography>
                  </div>
                  <div>
                    <Typography variant={'caption'}>Aircraft:</Typography>
                    <Typography>{aircraft}</Typography>
                  </div>
                  <div>
                    <ArrowForwardIcon />
                  </div>
                  <div>
                    <Button
                      color="primary"
                      disabled={isDownloading || isUploading}
                      onClick={download}
                      loading={isDownloading}
                      loadingPosition="start"
                      startIcon={<CloudDownloadIcon />}
                    >
                      {shortHandFile()}.xlsx
                    </Button>
                  </div>
                </Box>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem sx={{
                  "&": {
                    '&:before': {
                      flex: 0,
                      padding: 0,
                    }
                  }
                }}>
              <TimelineSeparator>
                <TimelineDot>
                  <PublishIcon />
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography>Upload .xlsx template with data</Typography>
                <DropzoneArea
                  dropzoneText={'Drag & Drop or click to upload a .xlsx file'}
                  onChange={(e) => handleFileChange(e)}
                  filesLimit={1}
                  previewText="Selected file"
                  selectedFilename={uploadFilename}
                  disabled={!Boolean(uploadFile)}
                />
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={isUploading || !Boolean(uploadFile)}
            onClick={submit}
            loading={isUploading}
            loadingPosition="start"
            startIcon={<CloudUploadIcon />}
          >
            Upload File
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

// Temporary workaround for eventual consistent read issue (latest data not always fetched)
function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}

export default withRouter(ImportData);